import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const GuestSignupModal = ({
    isOpen,
    onClose,
    onGuestSignup,
    selectedClass,
    selectedDates = [],
    isLoading = false
}) => {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!email.trim()) {
            setEmailError('Email is required');
            return;
        }

        if (!validateEmail(email)) {
            setEmailError('Please enter a valid email address');
            return;
        }

        setEmailError('');
        onGuestSignup(email);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (emailError) {
            setEmailError('');
        }
    };

    if (!isOpen || !selectedClass) return null;

    const totalPrice = selectedDates.length > 0
        ? selectedDates.length * selectedClass.price
        : selectedClass.price;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-900 rounded-lg p-6 max-w-md w-full">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-semibold text-white">
                        Join Class as Guest
                    </h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-white"
                        disabled={isLoading}
                    >
                        <XMarkIcon className="h-6 w-6" />
                    </button>
                </div>

                <div className="mb-6">
                    <div className="bg-gray-800 rounded-lg p-4 mb-4">
                        <h4 className="text-white font-medium mb-2">{selectedClass.name}</h4>
                        <div className="text-gray-300 text-sm space-y-1">
                            <div>Price: £{selectedClass.price}{selectedClass.cycleType !== undefined && ' per session'}</div>
                            {selectedDates.length > 0 ? (
                                <>
                                    <div>Sessions: {selectedDates.length}</div>
                                    <div className="font-medium text-emerald-400">Total: £{totalPrice.toFixed(2)}</div>
                                </>
                            ) : (
                                <div>Date: {new Date(selectedClass.startDate).toLocaleDateString('en-GB', {
                                    weekday: 'long',
                                    day: 'numeric',
                                    month: 'long',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}</div>
                            )}
                        </div>
                    </div>

                    <div className="bg-blue-900/20 border border-blue-600 rounded-lg p-4 mb-4">
                        <p className="text-blue-400 text-sm">
                            <strong>Guest Account:</strong> We'll create a guest account with your email address.
                            You can upgrade to a full account later to access additional features.
                        </p>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                            Email Address
                        </label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={handleEmailChange}
                            className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                            placeholder="Enter your email address"
                            disabled={isLoading}
                            required
                        />
                        {emailError && (
                            <p className="mt-1 text-sm text-red-400">{emailError}</p>
                        )}
                    </div>

                    <div className="flex gap-3 pt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="flex-1 px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg font-medium transition-colors"
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="flex-1 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Creating Account...' : `Join Class - £${totalPrice.toFixed(2)}`}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default GuestSignupModal;
